import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { AudiPlatformProvider, Button } from '@audi/audi-ui-react';
import { ButtonSize, ButtonVariant } from '@audi/audi-ui-react/dist/types/components/Button/Button.types';
import React from 'react';
import ReactDOM from 'react-dom';

@Component({
    selector: 'app-audi-button',
    template: ''
})
export class AudiButtonComponent implements AfterViewInit, OnChanges, OnDestroy {
    //https://react.ui.audi/?path=/story/components-buttons-overview--page
    @Input() text = '';
    @Input() variant = 'primary';
    @Input() size = 'medium';
    @Input() className = '';
    @Input() disabled: boolean;

    ElementToShow = () => (
        <AudiPlatformProvider>
            <Button
                className={this.className}
                size={this.size as ButtonSize}
                variant={this.variant as ButtonVariant}
                disabled={this.disabled}>
                {this.text}
            </Button>
        </AudiPlatformProvider>
    );

    constructor(private hostRef: ElementRef) { }

    ngOnChanges(changes: SimpleChanges): void {
        //console.log('ngOnChanges: ' + this.hostRef.nativeElement);
        this.render();
    }

    ngAfterViewInit(): void {
        //console.log('ngAfterViewInit');
        this.render();
    }

    ngOnDestroy(): void {
        //console.log('ngOnDestroy');
        ReactDOM.unmountComponentAtNode(this.hostRef.nativeElement);
    }

    private render() {
        ReactDOM.render(<this.ElementToShow />, this.hostRef.nativeElement);
    }
}
